<template>
  <BaseText
    v-bind="$attrs"
    :styleExtension="styleExtension"
  >
    <slot />
  </BaseText>
</template>

<script setup lang="ts">
import { useStyle } from '@composables/use-style';
import { useStyleExtension } from '@v1/composables/text';
import BaseText from '@v1/components/base/BaseText.vue';

const { colors, fontStyle } = useStyle();

const props = defineProps({
  size: {
    type: String,
    required: false,
    default: 'MD',
  },
  weight: {
    type: String,
    required: false,
    default: 'MD',
  },
});

const styleExtension = useStyleExtension({
  container: {
    color: colors.PRIMARY3(),
    fontSize: fontStyle.SIZE[props.size],
    fontWeight: fontStyle.WEIGHT[props.weight],
  },
});
</script>
